import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-zform',
  templateUrl: './zform.component.html',
  styleUrls: ['./zform.component.css']
})
export class ZformComponent implements OnInit {

  title = "ZForm";

  constructor() { }

  ngOnInit() {
  }

}
